export const BarcodePrintingPublish = () => {
    return (
        <>
            <div className="content_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">바코드 인쇄</h3>
                    <div className="filter_toolbar">
                        <button className="btn btn-info color2"><img src={process.env.PUBLIC_URL + "/assets/images/icon_download.png"} alt="" />엑셀 양식 다운로드</button>
                        <button className="btn btn-primary w-80px">인쇄</button>
                    </div>
                </div>

                <div className="barcode_sections">
                    <div className="left">
                        <div className="d-flex align-items-center justify-content-between">
                            <h5 className="subheading">제품정보</h5>
                            <div className="filter_toolbar">
                                <button className="btn btn-info w-100px"><img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt="" />제품 검색</button>
                                <button className="btn btn-outline-dark w-150px px-0"><img src={process.env.PUBLIC_URL + "/assets/images/icon_import.png"} alt="" />엑셀 가져오기</button>
                            </div>
                        </div>
                        <table className="table table-bordered my_table">
                            <thead>
                                <tr>
                                    <th style={{ width: "7.14%" }}>

                                    </th>
                                    <th style={{ width: "19.38%" }}>이미지</th>
                                    <th style={{ width: "58.1%" }}>제품 상세</th>
                                    <th>인쇄 수량</th>
                                </tr>
                            </thead>
                            <tbody>
                                {[0, 1, 2].map(() => (<tr>
                                    <td className="text-center">
                                        <button className="btn btn-link p-0"><img src={process.env.PUBLIC_URL + "/assets/images/icon_btn_delete.png"} alt="" /></button>
                                    </td>
                                    <td className="p-4px"><img src={process.env.PUBLIC_URL + "/assets/images/ex_image.png"} alt="" width={172} /></td>
                                    <td>
                                        <div className="line1">S1-WIN Emb Compact 7 C7E</div>
                                        <div className="line2">TNA-00022</div>
                                        <div className="line3">설명칸입니다. 설명칸입니다. 설명칸입니다. 설명칸입니다.설명칸입니다.설명칸 설명칸</div>
                                    </td>
                                    <td>
                                        <input type="text" className="form-control" />
                                    </td>
                                </tr>))}
                                <tr className="blue">
                                    <td></td>
                                    <td className="text-center"><span className="f-15">총 품목</span></td>
                                    <td><span className="f-15">3개 품목</span></td>
                                    <td className="text-end"><span className="f-15">총 3장</span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="right">
                        {/* <iframe /> */}
                    </div>
                </div>
            </div>
        </>
    );
}